import { useCallback, useEffect, useRef, useState } from 'react';
import {
  getOperatingContext, isOperatingContextReady, OPERATING_GROUP_STORAGE_KEY, useOperatingContext,
} from '../utils/operatingContextLifecycle';

export interface SelectedOperatingGroup {
  groupId: string | null;
  changedInAnotherTab: boolean;
  ready: boolean;
  isCurrent: (groupId: string | null) => boolean;
}

export const useSelectedOperatingGroup = (): SelectedOperatingGroup => {
  const context = useOperatingContext();
  const invalidatedGeneration = useRef<number | null>(null);
  const [, refresh] = useState(0);

  useEffect(() => {
    const storageChanged = (event: StorageEvent) => {
      const current = getOperatingContext();
      if (event.key === null || event.key === 'token' ||
          (event.key === OPERATING_GROUP_STORAGE_KEY && event.newValue !== current.groupId)) {
        invalidatedGeneration.current = current.generation;
        refresh(value => value + 1);
      }
    };
    window.addEventListener('storage', storageChanged);
    return () => window.removeEventListener('storage', storageChanged);
  }, []);

  const isCurrent = useCallback((groupId: string | null) => {
    const current = getOperatingContext();
    return isOperatingContextReady(context, context.token) &&
      invalidatedGeneration.current !== context.generation &&
      current.generation === context.generation && current.token === context.token &&
      isOperatingContextReady(current, context.token) &&
      current.groupId === context.groupId && current.groupId === groupId;
  }, [context]);
  const changedInAnotherTab = invalidatedGeneration.current === context.generation;
  const ready = !changedInAnotherTab && isOperatingContextReady(context, context.token);

  return {
    groupId: context.token === localStorage.getItem('token') ? context.groupId : null,
    changedInAnotherTab, ready, isCurrent,
  };
};

export const OPERATING_GROUP_CHANGED_IN_ANOTHER_TAB_MESSAGE =
  'Робочу групу змінено в іншій вкладці. Оновіть сторінку, щоб переглянути дані.';
